import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useFetchList } from "../../hooks/useFetchList";
import { ensureChartSetup } from "./ChartSetup";
import { inferFirstKey } from "../../api";

ensureChartSetup();

export default function PurchaseByCategoryChart({ headers = {} }) {
  const { data, loading, error } = useFetchList(
    "/v1/frontend/expensesByCategory",
    {
      headers,
    }
  );

  const chart = useMemo(() => {
    if (!data || data.length === 0) return null;
    const keys = Object.keys(data[0] || {});
    const catKey = inferFirstKey(keys, [/(category|name)$/i]);
    const valKey = inferFirstKey(
      keys.filter((k) => k !== catKey),
      [/(purchase|amount|total|cost|expense)/i]
    );
    const labels = data.map((r) => r[catKey]);
    const values = data.map((r) => Number(r[valKey]) || 0);
    return {
      labels,
      datasets: [
        {
          label: "Expenses",
          data: values,
          backgroundColor: "#f6c23e",
        },
      ],
    };
  }, [data]);

  if (loading) return <div style={{ textAlign: "center" }}>Loading...</div>;
  if (error) {
    return (
      <div style={{ color: "#d33" }}>
        Failed to load: {error.message || "Unknown error"}
      </div>
    );
  }
  if (!data || data.length === 0) {
    return <div>No data available.</div>;
  }
  if (!chart) return <div>No chart data.</div>;
  return (
    <div
      style={{
        width: "100%",
        minHeight: 220,
        height: "30vw",
        maxHeight: 340,
        boxSizing: "border-box",
      }}
    >
      <Bar
        data={chart}
        options={{
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.dataset.label || "";
                  const value = context.parsed.y || 0;
                  const formattedValue = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(value);
                  return `${label}: ${formattedValue}`;
                },
              },
            },
          },
          maintainAspectRatio: false,
          scales: {
            x: { ticks: { font: { size: 12 } } },
            y: {
              ticks: {
                font: { size: 12 },
                callback: function (value) {
                  return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(value);
                },
              },
            },
          },
        }}
      />
    </div>
  );
}
